import { createSelector } from 'reselect';
import { AUTH_STATUS_AUTHENTICATED } from '../types/user';

/**
 *
 * @param {*} state react state
 * @returns {import('../reducers/user.reducer').UserState}
 */
const user = (state) => state.user;

/**
 *
 */
export const projectListSelector = createSelector(
  user,
  (item) => item.projects
);

/**
 *
 */
export const gimProjectListSelector = createSelector(
  user,
  (item) => item.gimProjects
);

/**
 *
 */
export const fileListSelector = createSelector(user, (item) => item.fileList);

/**
 *
 */
export const fileUrlSelector = createSelector(user, (item) => item.gltfFileUrl);

/**
 *
 */
export const fileTypeSelector = createSelector(user, (item) => item.fileTypes);

const authStatus = (state) => state.auth?.status;

/**
 *
 */
export const userInfoSelector = createSelector(
  [user, authStatus],
  (item, status) => (status === AUTH_STATUS_AUTHENTICATED ? item.userInfo : {})
);
/**
 *
 */
export const userIdSelector = createSelector(
  [user, authStatus],
  (item, status) =>
    // TODO: migrate consumer sentinel 0 to undefined.
    status === AUTH_STATUS_AUTHENTICATED ? item.userId : 0
);

/**
 *
 */
export const userAvatarSelector = createSelector(user, (item) => item.avatar);

/**
 *
 */
export const initProjectListSelector = createSelector(
  user,
  (item) => item.initialtProjectList
);
/**
 *
 */
export const selectprojectwithIdSelector = createSelector(
  user,
  (item) => item.selectprojectwithId
);
